import { render, staticRenderFns } from "./UpdateTicket.vue?vue&type=template&id=d11c2e0e&"
import script from "./UpdateTicket.vue?vue&type=script&lang=js&"
export * from "./UpdateTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports